module.exports = __webpack_public_path__ + "static/media/bg2.ad3c8431.png";